// frontend/src/components/Carousel.js
import React, { useState, useEffect } from 'react';

// Импортируем изображения (замените пути на свои)
import slide1 from '../images/01_clothes_1_foto-walmart-10-scaled.webp';
import slide2 from '../images/01_clothes_1_foto-walmart-2-scaled.webp';
// добавьте остальные слайды

const slides = [
    {
        image: slide1,
        title: 'Контактная точечная сварка',
        description: 'Современное оборудование для промышленности',
        targetId: 'features-section',
    },
    {
        image: slide2,
        title: 'Автоматизация бизнеса',
        description: 'Комплексные решения от 1С до промышленных систем',
        targetId: 'services-section',
    },
];

function Carousel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(null);
    const [isAnimating, setIsAnimating] = useState(false);
    const [contentVisible, setContentVisible] = useState(true);
    const [backgroundImage, setBackgroundImage] = useState(slides[0].image);

    // Предзагрузка изображений
    useEffect(() => {
        slides.forEach(slide => {
            const img = new Image();
            img.src = slide.image;
        });
    }, []);

    const changeSlide = (newIndex) => {
        if (isAnimating) return;
        setIsAnimating(true);
        setContentVisible(false); // прячем текст

        // Ждём 300ms, пока текст исчезнет
        setTimeout(() => {
            // Меняем фон на следующий слайд
            setBackgroundImage(slides[newIndex].image);
            setCurrentIndex(newIndex);
            setContentVisible(true); // показываем текст
            setTimeout(() => setIsAnimating(false), 300);
        }, 300);
    };

    const nextSlide = () => {
        const newIndex = (currentIndex + 1) % slides.length;
        changeSlide(newIndex);
    };

    const prevSlide = () => {
        const newIndex = (currentIndex - 1 + slides.length) % slides.length;
        changeSlide(newIndex);
    };

    const goToSlide = (index) => {
        changeSlide(index);
    };

    const handleLearnMore = () => {
        const targetId = slides[currentIndex].targetId;
        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const currentSlide = slides[currentIndex];

    return (
        <div className="custom-carousel">
            {/* Фон с плавной сменой (crossfade) */}
            <div
                className="custom-carousel__bg custom-carousel__bg--active"
                style={{ backgroundImage: `url(${backgroundImage})`, opacity: 1 }}
            />

            <div className="custom-carousel__overlay"></div>

            {/* Контент с анимацией появления/исчезновения */}
            <div
                className={`custom-carousel__content ${contentVisible ? 'custom-carousel__content--visible' : 'custom-carousel__content--hidden'}`}
            >
                <h2 className="custom-carousel__title">{currentSlide.title}</h2>
                <p className="custom-carousel__description">{currentSlide.description}</p>
                <button className="custom-carousel__button" onClick={handleLearnMore}>
                    Подробнее
                </button>
            </div>

            {/* Стрелки */}
            <button className="custom-carousel__arrow custom-carousel__arrow--prev" onClick={prevSlide}>
                ‹
            </button>
            <button className="custom-carousel__arrow custom-carousel__arrow--next" onClick={nextSlide}>
                ›
            </button>

            {/* Точки */}
            <div className="custom-carousel__dots">
                {slides.map((_, idx) => (
                    <button
                        key={idx}
                        className={`custom-carousel__dot ${idx === currentIndex ? 'custom-carousel__dot--active' : ''}`}
                        onClick={() => goToSlide(idx)}
                    />
                ))}
            </div>
        </div>
    );
}

export default Carousel;